import { Layer } from './layer-accessor';
/**
 * Get the actual selected exercise id for an alternate exercise group
 */
export const getSelectedExerciseId = ({ workoutAlternateGroupId, selectedExerciseId }, athleteActualWorkoutLayer) => {
    const actualWorkoutAlternateGroupEdit = Layer(athleteActualWorkoutLayer).alternateGroupEdit({ workoutAlternateGroupId });
    return (actualWorkoutAlternateGroupEdit?.selectedExerciseId ?? selectedExerciseId);
};
/**
 * Get the actual selected exercise for an alternate exercise group
 */
export const getSelectedExercise = (alternateExerciseGroup, athleteActualWorkoutLayer) => {
    const selectedExerciseId = getSelectedExerciseId(alternateExerciseGroup, athleteActualWorkoutLayer);
    return alternateExerciseGroup.exercises.find((exercise) => exercise.workoutExerciseId === selectedExerciseId);
};
//# sourceMappingURL=alternateExercise.js.map